import React from 'react';
import { Table } from "react-bootstrap";
import { Link } from 'react-router-dom';
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import Spinner from 'layouts/public/spinner/Spinner'

class MembershipSummary extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState();
	}

	initialState = () => {
        return {
			loading: true,
			membershipLevels: []
		};
    }

    componentDidMount() {
		this.get();
    }

	get = () => {
        new API().post(APIModules.Admin.url('/sponsorDashboard/getMembershipSummary'), null,
            {
                success: (r) => {
                    this.setState({ membershipLevels: r.data.items, loading: false });
                }
			});

    }

	onExportData = () => {
		const rq = {
			RowCount: 5000,
			SearchText: "",
			SortDirection: "ASC",
			SortField: "sponsorName"
		};

		new API().post(APIModules.Sponsor.url('/sponsorSetup/searchExport', rq), rq,
			{
				success: (sr) => {
					new API().download(sr.data);
				}
			});
	}

	renderMembershipLevels = () => {

		let items = [];
		let total = 0;

		this.state.membershipLevels.forEach((ml) => {
			items.push(
				<tr key={ml.membershipLevelId}>
					<td className="react-grid-Cell">{ml.membershipLevelName}</td>
					<td className="react-grid-Cell">
						{ml.total > 0 ?
							<Link to={'/admin/sponsorSetup?membershipLevelId=' + ml.membershipLevelId + "&membershipLevelName=" + encodeURIComponent(ml.membershipLevelName)}>
								{ml.total}
							</Link>
						:
							<span>-</span>
						}
					</td>
				</tr>
			);

			total += ml.total;
		});

		items.push(
			<tr key="Total">
				<td className="react-grid-Cell"><b>Total</b></td>
				<td className="react-grid-Cell">
					{total > 0 ?
						<Link to="#" onClick={this.onExportData}>{total}</Link>
					:
						<span>{total}</span>
					}	
				</td>
			</tr>
		);

		return items;
	}

	render() {
		if (this.state.loading)
			return <Spinner />

		return (
			<Table condensed>
				<thead>
					<tr>
						<th className="col-md-2">Level</th>
						<th className="col-md-2">Total</th>
					</tr>
				</thead>
				<tbody>
					{this.renderMembershipLevels()}
				</tbody>
			</Table>
		)
	}
}

export default MembershipSummary;



// WEBPACK FOOTER //
// ./src/areas/main/dashboard/adminSponsorDashboard/membershipSummary/MembershipSummary.js